<template>
    <div>
        <h2 style="color: #ff8800">案例1：玻璃厂 ⇋ 酒厂 ⇋ 经销商<span style="display: inline-block; width: 30px"></span>带托循环</h2>
        <h3 style="margin-top: 10px">行业特点</h3>
        <p>淡旺季需求<strong>波动达50%</strong></p>
        <p>旺季：每年9月-12月为备货旺季，旺季托盘补充量是日常数量的两倍;</p>
        <p>淡季：春节前后位该企业销售高峰期，1月开始托盘陆续大量腾出，进入生产淡季。</p>
        <h3 style="margin-top: 10px" >解决方案</h3>
        <h4 style="margin-top: 8px" >柔性租赁</h4>
        <p>基于波峰波谷的需求变化特点，普拉托为其提供6万片托盘的综合解决方案，其中2万片自购，4万片进行柔性租赁。自购托盘与普拉托托盘采用同一标准，普拉托统一为其提供维护及异地回收服务。</p>
        <h4 style="margin-top: 8px" >全期服务</h4>
        <p>普拉托为该企业提供的托盘全部携带RFID、SG1、二维码三码合一的托盘，为其及其下游货物带板运输过程中提供货物生产及物流信息跟踪、追溯服务，运营期间为其提供条码维护更新、旧托维修等服务。</p>
        <div style="margin-top: 10px; display: flex">
            <Steps :current="5" direction="vertical" style="margin-top: 35px">
                <Step title="减少返空" icon="md-checkmark-circle" content="降低该企业从下游空托盘拉回成本">
                    <template></template>
                </Step>
                <Step title="降低固定资产" icon="md-checkmark-circle" content="企业只需按波谷使用量购买托盘"></Step>
                <Step title="减少仓储成本" icon="md-checkmark-circle" content="随借随还，没有闲置托盘"></Step>
                <Step title="提高托盘流通率" icon="md-checkmark-circle" content="使用标准化托盘，无需区分托盘归属"></Step>
                <Step title="减少丢失" icon="md-checkmark-circle" content="托盘转移，保管权同步转移"></Step>
            </Steps>
            <img src="~assets/image/industry-case/industry-case-wine.png" style="width: 75%" />
        </div>

        <h2 style="color: #ff8800; margin-top: 20px">案例2：能源提供公司 ⇋ 塑料贸易公司<span style="display: inline-block; width: 30px"></span>无人仓、托盘共享</h2>
        <h3 style="margin-top: 10px" >合作流程</h3>
        <p style="margin-top: 7px" >1、普拉托预送 200 片给塑料贸易公司进行先期使用，不收取租金。200 片托盘由塑料贸易公司分 4 期付费采购，单价为 250 元/片，即每月支付费用 12500 元。</p> 
        <p style="margin-top: 7px">2、能源提供公司安排塑料托盘带托到塑料贸易公司，塑料贸易公司可用预送托盘进行置换（非货物过板），即在系统当天做出退租申请，即可享受 10.5 元/片租金收益。如非当天，30 天内未使用天数即可按 0.35 元/天进行补贴。退租数量达到 200件，另可额外享受 8 元/片运营补贴收益。 </p>
        <p style="margin-top: 7px">3、塑料贸易公司安排 150 平方米空地与普拉托设置无人前置仓，该公司可使用无人前置仓进行随租随还。能源提供公司带托至该公司的托盘可分批次归还至无人前置仓，不限退租数量均可享受 8 元/片运营补贴收益。 </p>
        <p style="margin-top: 7px">4、塑料贸易公司收到的能源提供公司托盘可二次带托至其他客户，10 片以上均可异企异地由普拉托免费回收，并可额外享受 5 元/片客户开拓收益。 </p>
        <p style="margin-top: 7px">5、普拉托运营根据退租情况安排回收及相关工作。</p>
        <div style="text-align: center">
            <img src="~assets/image/industry-case/industry_case_fossil.png" style="width: 75%" />
        </div>
        <h4 style="margin-top: 20px" >合作收益</h4>
        <p style="margin-top: 7px">一个季度后，理论上塑料贸易公司托盘数量已经足够循环使用，并有结余，补贴即可。作为托盘购买款项进行托盘投资，每年累计可购托盘数：50*12=600 片，此部分托盘可在普拉托平台上共享并享受托盘共享收益。能源提供公司在普拉托带板运输方案设计下实现了下游公司运输链优化，缓解托盘压力，盘活托盘存量。</p>


    </div>
</template>

<script>
export default {
    props: {
        caseList: Array
    }

}
</script>

<style lang="scss" scoped>

/deep/.ivu-steps-item.ivu-steps-status-finish .ivu-steps-head-inner span, .ivu-steps-item.ivu-steps-status-finish .ivu-steps-head-inner>.ivu-steps-icon { color: #ff8800}
/deep/.ivu-steps-item.ivu-steps-status-finish .ivu-steps-tail>i:after {background-color: #ff8800;}

.case {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    li {
        // width: 500px;
        height: 275px;
        // background: #eee;
        margin-top: 20px;
        display: flex;
        .imgs {
            width: 270px;
            height: 275px;
            img {
                width: 270px;
                height: 275px;
            }
        }
        .text {
            width: 110px;
            margin: 20px 0 0 50px;
            p {
                // font-size: 16px;
                font-weight: bold;
            }
            div {
                width: 60px;
                height: 30px;
                background: #ff9000;
                color: #fff;
                text-align: center;
                line-height: 30px;
                border-radius: 3px;
                margin-top: 80px;
                cursor: pointer;
            }
        }
    }
}
</style>